module.exports = __webpack_public_path__ + "images/cov-05-faq-desktop.png";